import { fork, takeEvery, takeLatest } from 'typed-redux-saga';
import { setContentType, setTokensType } from '../../session/sessionSlice';
import cleanCsrSessionTokensSaga from './cleanCsrSessionTokensSaga';
import { hydrateType } from '@spa/lib/store/HydrateAction';
import refreshCsrSessionTokenSaga from './refreshCsrSessionTokenSaga';
import updateCsrSessionSaga from './updateCsrSessionSaga';
import watchAndNotifySessionChanges from '@spa/lib/store/sagas/session/watchAndNotifySessionChanges';

const reduxInitType = '@@INIT';

function* sessionSaga(): Generator {
  yield* updateCsrSessionSaga();

  yield* takeEvery([setContentType, setTokensType, hydrateType], updateCsrSessionSaga);
  yield* takeLatest(
    [setContentType, setTokensType, hydrateType, reduxInitType],
    cleanCsrSessionTokensSaga
  );
  yield* takeLatest(
    [setContentType, setTokensType, hydrateType, reduxInitType],
    refreshCsrSessionTokenSaga
  );
  yield* fork(watchAndNotifySessionChanges);
}

export default sessionSaga;
